export default __webpack_public_path__ + "static/media/CLO logo.b91f2fab.svg";